import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiFunnel } from 'react-icons/pi';
import {
  BUTTON_VARIANT,
  IButtonProps,
} from 'types/components/button/button.interface';
import { II18nextPrefix } from 'types/components/components.interface';
import { getFilterSubmitLabel } from 'utils/global/translation.utils';

interface IFormButtonFilterProps extends IButtonProps, II18nextPrefix {}

const FormButtonFilter = ({
  i18nextPrefix,
  ...props
}: IFormButtonFilterProps) => {
  const { t } = useTranslation();

  return (
    <Button variant={BUTTON_VARIANT.submit} onlyIcon {...props}>
      <Button.Description description={getFilterSubmitLabel(t, i18nextPrefix)} />
      <Button.Icon icon={<PiFunnel />} />
    </Button>
  );
};

export default FormButtonFilter;
